import { combineReducers } from "redux";

import categorySlice from "./categoryReducer";
import notificationReducer from "./notificationReducer";
import productSlice from "./productReducer";
import supplierSlice from "./supplierReducer";
import userDataReducer from "./userDataReducer";

const rootReducer = combineReducers({
	categories: categorySlice,
	products: productSlice,
	suppliers: supplierSlice,
	user: userDataReducer,
	notifications: notificationReducer,
});

export default rootReducer;
